export enum UniformItemBottomTypes {
  Skirts = "SKIRTS",
  Shorts = "SHORTS",
}
